module.exports = __webpack_public_path__ + "static/media/loginBackground.c7fe6dde.png";